// extracted by mini-css-extract-plugin
module.exports = {"summary":"dd31006766--summary--lRafa","balance_container":"dd31006766--balance_container--phRxh"};